import { render, staticRenderFns } from "./BoxObjeto.vue?vue&type=template&id=22397c36&scoped=true&"
import script from "./BoxObjeto.vue?vue&type=script&lang=js&"
export * from "./BoxObjeto.vue?vue&type=script&lang=js&"
import style0 from "./BoxObjeto.vue?vue&type=style&index=0&id=22397c36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22397c36",
  null
  
)

export default component.exports